import React, { useState } from "react";
import { DatePicker, Button, Space, Calendar, Tag } from "antd";
import { set } from "lodash";
import moment from "moment";

import styles from "./styles.module.scss"
import { MinusOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

export const DateRangePickerMode = {
    'datepicker': 1,
    'rangepicker': 2
}

export default function DateRangePickerCombo({ dates, setDates, mode, setMode }) {
    // const [mode, setMode] = useState(Mode.datepicker)
    const [open, setOpen] = useState(false);

    // const [dates, setDates] = useState([moment(), moment()])


    return (
        <div>
            {
                mode === DateRangePickerMode.datepicker && <DatePicker
                    open={open}
                    picker="date"
                    allowClear={false}
                    value={dates[0]}
                    onChange={(date) => {
                        setDates([date, date])
                    }}
                    onOpenChange={(status) => setOpen(status)}
                    renderExtraFooter={() => {
                        return <Tag
                            style={{ cursor: "pointer" }}
                            color="gold"
                            onClick={() => {
                                setMode(DateRangePickerMode.rangepicker)
                                setOpen(true)
                            }}

                        >
                            Switch to Date Range Mode
                        </Tag>
                    }}
                    showNow={true}
                    showTime={false}
                    className={styles.datepicker}
                />
            }
            {
                mode === DateRangePickerMode.rangepicker && <RangePicker
                    className={styles.rangepicker}
                    open={open}
                    value={dates}
                    onChange={(date) => {
                        setDates(date)
                    }}
                    allowClear={false}
                    allowEmpty={[false, false]}
                    onOpenChange={(status) => setOpen(status)}
                    renderExtraFooter={() => {
                        return <Tag
                            style={{ cursor: "pointer" }}
                            color="gold"
                            onClick={() => {
                                setMode(DateRangePickerMode.datepicker)
                                setOpen(true)
                                setDates([dates[0], dates[0]])
                            }}>
                            Switch to Single Date Mode
                        </Tag>
                    }}

                    separator={
                        <MinusOutlined style={{
                            color: '#00000040'
                        }} />
                    }

                    ranges={{
                        // Today: [moment(), moment()],
                        // Yesterday: [
                        //     moment().subtract(1, "day"),
                        //     moment().subtract(1, "day"),
                        // ],
                        "Last 7 Days": [moment().subtract(6, "days"), moment()],
                        "This Week": [moment(), moment().add(6, "days")],
                        "This Month": [
                            moment().startOf("month"),
                            moment().endOf("month"),
                        ],
                    }}

                />
            }
        </div>
    );
}
